import { Toaster as Sonner, toast } from "sonner";

/** One toaster per app; theme follows the html class. */
export function Toaster({ theme }: { theme: "light" | "dark" }) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      toastOptions={{ classNames: { toast: "font-sans text-sm rounded-xl border shadow-lg" } }}
    />
  );
}

export { toast };
